import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { AdContainer } from "../AdContainer";
import { AdSlotIds } from "@/shared/types";
import { CarouselAdCustomFallback } from "./CarouselAdCustomFallback";
import { useFarbwelt } from "@/hooks";
export const CarouselAd = () => {
    const { isFarbweltActive } = useFarbwelt();
    return (_jsx(_Fragment, { children: _jsx(Box, { display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: "100%", height: "100%", children: !isFarbweltActive ? (_jsx(AdContainer, { adSlotId: AdSlotIds.AD_CAROUSEL, width: "100%", height: "100%", display: "flex", customFallback: _jsx(CarouselAdCustomFallback, {}), dynamicSlot: true })) : (_jsx(CarouselAdCustomFallback, {})) }) }));
};
